import Vue from 'vue'
import * as FlixModule from 'bookingflix_framework'


Object.keys(FlixModule).forEach(function (r) {
  const name = r.replace('Flix', '').toLowerCase()
  Vue.component('b-flix-' + name, FlixModule[r])
})
